import * as React from 'react'

function SvgFlasher(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={25}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <path
        d="M11.225 1.398C11.225.98 11.55.6 12 .6s.775.38.775.798v1.851c0 .418-.325.798-.775.798s-.775-.38-.775-.798V1.398zM15.407 1.97a.768.768 0 011.024-.435c.4.176.566.643.414 1.031l-.668 1.71a.775.775 0 01-.718.5.758.758 0 01-.305-.064.807.807 0 01-.415-1.03l.668-1.711zM8.593 1.97a.768.768 0 00-1.024-.435.807.807 0 00-.415 1.03l.668 1.711c.118.302.402.5.72.5a.756.756 0 00.304-.064.807.807 0 00.414-1.03L8.593 1.97zM3.819 4.192a.76.76 0 011.112 0l1.234 1.31a.815.815 0 010 1.11.763.763 0 01-1.112 0L3.819 5.305a.815.815 0 010-1.112zM20.18 5.304a.815.815 0 00.001-1.112.76.76 0 00-1.112 0l-1.235 1.31a.815.815 0 000 1.11.763.763 0 001.113 0l1.234-1.308z"
        fill={props.color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.045 9.073C6.235 7.152 7.626 5.6 9.388 5.6h5.222c1.76 0 3.152 1.551 3.346 3.473v.001l1.02 9.335h.643c.494 0 .781.45.781.853v3.284c0 .404-.287.854-.781.854H4.38c-.494 0-.781-.45-.781-.854v-3.284c0-.404.287-.854.781-.854h.643l1.021-9.335zm3.343-1.766c-.858 0-1.674.781-1.79 1.953v.005l-1.001 9.143h10.806l-1-9.146c-.118-1.173-.936-1.955-1.793-1.955H9.388zM5.163 20.116v1.577h13.674v-1.577H5.163z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgFlasher)
const MemoForwardRef = React.memo(ForwardRef)
export default MemoForwardRef
